// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ProductsController from "./products_controller"
application.register("products", ProductsController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PostsFilterController from "./posts_filter_controller"
application.register("posts-filter", PostsFilterController)
import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)
